/* file description */
import { createAssetData, approvalheadRecordData, updataAssetData } from '@/api/cascade';

interface ModuleRequestPropsType {
  ns: string;
  module: string;
  taskId: string;
  values: Record<string, any>;
  recordId: string;
}

export const approvalRequest = async ({ ns, module, taskId, values, recordId }: ModuleRequestPropsType) => {
  const headRecord = {
    appId: ns!,
    modelId: module,
    record: [{
      children: [],
      recordId,
      values,
    }],
    refHeadField: '',
    refName: '',
  };
  const res = await approvalheadRecordData(headRecord, taskId);
  return res;
};


export const moduleRequest = async ({ ns, module, type, recordId, values }) => {
  const headRecord = {
    appId: ns,
    modelId: module,
    record: [
      {
        recordId,
        values,
      },
    ],
  };

  let res = null;

  if (type == 'create') {
    res = await createAssetData({
      request: {
        headRecord,
      },
    });
  } else {
    res = await updataAssetData({
      request: {
        headRecord,
      },
    });
  }
  return res;
};
